import { render, staticRenderFns } from "./ListDetailUpsertComponent.vue?vue&type=template&id=b2fa4d04&"
import script from "./ListDetailUpsertComponent.vue?vue&type=script&lang=ts&"
export * from "./ListDetailUpsertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports